module.exports = __webpack_public_path__ + "media/src/images/abouts/brands/starbucks-06fcaae492dd33ff1a286221660d342f.jpg";